import { render, staticRenderFns } from "./UnitMeasure.vue?vue&type=template&id=7c290cae&scoped=true&"
import script from "./UnitMeasure.vue?vue&type=script&lang=js&"
export * from "./UnitMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c290cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
